import { useContext, useEffect, useState } from "react"
import { useNavigate } from "react-router"
import { UserContext } from "../context"

export function ProtectedRoute({
  permission,
  children,
}: {
  permission?: string
  children: React.ReactNode
}): JSX.Element {
  const user = useContext(UserContext)
  const navigate = useNavigate()
  const [permissions, setPermissions] = useState<string[]>([])
  useEffect(() => {
    if (permission) {
      setPermissions(permission.split(",").map(p => p.trim()))
    }
  }, [permission])
  useEffect(() => {
  
    if ((!user || !user.user) && window.location.pathname !== "/") {
      navigate("/login")
    //   console.log('will redirect')
    } else if (permissions.length>0&&!permissions.includes(user.user?.userRole || "")) {
      // console.log('permissions:', permissions, 'userrole:',user.user?.userRole, 'required permission string:', permission)
      // console.log('no permission, will redirect')

      navigate("/")
    }else{
      //user is logged in and no permission is required for the page, allow it
    }
  }, [user,navigate, permissions])

  if (!user || !user.user) {
    return <></>
  } else if (permissions.length>0&&!permissions.includes(user.user?.userRole || "")) {
    return <></>
  } 
  return <>{children}</>
}
